import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import estimateField from "../../../../../service/estimateFields/estimateField"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import Radio from "../../../../components/1Click/form/Radio/Radio"
import HELP_LINKS from "../../../../constant/helpLinks"

import img from "./controlWiring.png"

const 配線配置ルール = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { controlWiring: shouldShow } = getDisplayCondition(values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={`配置／配線（配線幅\n・配線長・シールド）\nルール`}
      src={img}
      helpURL={HELP_LINKS["配置／配線（配線幅・配線長・シールド）ルール"]}
    >
      <RadioGroup name={estimateField.controlWiring.key} selectedValue={values.controlWiring} onChange={handlers.radio}>
        <OneClickFieldStack>
          <Radio value={ESTIMATE_CONSTANT["配置／配線（配線幅・配線長・シールド）ルール"].あり.value}>あり</Radio>
          <Radio value={ESTIMATE_CONSTANT["配置／配線（配線幅・配線長・シールド）ルール"].なし.value}>なし</Radio>
        </OneClickFieldStack>
      </RadioGroup>
      <OneClickFieldMessages error={errors?.controlWiring} />
    </OneClickField>
  )
}

export default 配線配置ルール
